import Image from 'next/image';
import { getFlagPath } from '../../shared/useUtils';
import { CountryListStyle } from '../../styles/components/countries';

export interface ICountryListProps {
  title: string;
  description: string;
  regions: {
    name: string;
    countries: {
      name: string;
      code: string;
      path: string;
      services?: { name?: string; price: string }[];
    }[];
  }[];
}

const CountryList = (props: ICountryListProps) => {
  return (
    <div className={CountryListStyle.CountryList}>
      <h1>{props.title}</h1>
      <p>{props.description}</p>
      {props.regions.map((region, index) => {
        return (
          <div key={index} className={CountryListStyle['regions']}>
            <h3>{region.name}</h3>
            <span className={CountryListStyle['line']} />
            <div className={CountryListStyle['countryWrap']}>
              {region.countries.map((country, index) => {
                return (
                  <a key={index} href={country.path}>
                    <div className={CountryListStyle['country']}>
                      <div className={CountryListStyle['country-name']}>
                        <div className={CountryListStyle['country-flag']}>
                          <Image
                            quality={90}
                            alt={`country-flag-${country.code}`}
                            src={getFlagPath(country.code)}
                            fill
                            sizes="80px"
                          />
                        </div>
                        <span>{country.name}</span>
                      </div>
                      <div className={CountryListStyle['country-services']}>
                        {country.services?.map((service, index) => {
                          return (
                            <div
                              key={index}
                              className={CountryListStyle['country-price']}>
                              {service.name && <span>{service.name}</span>}
                              <span>{service.price}</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </a>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CountryList;
